import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import type { PortSettingsPublic } from '@ipfabric/utils';
import { CustomPortSettingsWithModel } from 'app/features/DiscoverySettingsForms/components/AdvancedCli/CustomPortSettings/CustomPortSettingsWithModel';
import type { CustomPortSettingsModel } from 'app/features/DiscoverySettingsForms/components/AdvancedCli/CustomPortSettings/useCustomPortSettings';
import { useCustomPortSettingsModel } from 'app/features/DiscoverySettingsForms/components/AdvancedCli/CustomPortSettings/useCustomPortSettingsModel';
import { useWatch } from 'react-hook-form';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

type CustomPortsFieldValues = {
  customPorts: PortSettingsPublic[];
};

export const customPorts: FormSnippet<
  DiscoverySettingsObject,
  CustomPortsFieldValues,
  CustomPortsFieldValues,
  {
    model: CustomPortSettingsModel;
  }
> = {
  render: ({ hook }) => <CustomPortSettingsWithModel model={hook.model} />,

  use: ({ form }) => {
    const values = useWatch({ control: form.control, name: 'customPorts' });
    const model = useCustomPortSettingsModel({
      customPortSettings: values,
      onCustomPortSettingsChange: (customPorts) => {
        form.setValue('customPorts', customPorts, {
          shouldDirty: true,
        });
      },
    });

    return {
      model,
    };
  },

  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.customPorts = model.ports ?? [];
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.ports = transformedValues.customPorts ?? [];
  },
  schema: z.object({
    // All fields are already validated in separate component which handles add/editing records.
    // And we don't have any mechanism to display validation errors in table so we decided to skip validation at this level.
    customPorts: z.any(),
  }) as z.Schema<CustomPortsFieldValues>,
};
